import React from 'react'
import style from './style.module.css'
import AppDown from '../../../../assets/app-down-1-small.svg'
import { APP_NAME } from '../../../../constants/app'
export const EmailError = () => {
  return (
    <>
      <img
        style={{ width: '150px', height: '150px' }}
        src={AppDown}
        alt="App Down"
      />

      <h2 className={style.contentTitle}>Something went wrong on our end</h2>
      <p className={style.contentDescription}>
        Please try again or request a new verification from your profile in the
        app to continue.
      </p>
      <p className={style.contentDescription}>
        Get started by downloading our {APP_NAME} to your mobile device.
      </p>
    </>
  )
}

export default EmailError
